import { Button } from "@tellescope/design-system";
import {
  FilterBlockEditor,
  MultiSelect,
  type MultiSelectOption,
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@tellescope/ui";
import { type FreeformFieldOption, type FreeformFilterBlock } from "@tellescope/utils";
import { ListFilter } from "lucide-react";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export interface JourneysFilterPopoverProps {
  filterBlock: FreeformFilterBlock;
  fieldOptions: FreeformFieldOption[];
  journeyNameOptions: string[];
  onFilterChange: (block: FreeformFilterBlock) => void;
}

export const JourneysFilterPopover = ({
  filterBlock,
  fieldOptions,
  journeyNameOptions,
  onFilterChange,
}: JourneysFilterPopoverProps) => {
  const { t } = useTranslation("contacts");

  const journeySelectOptions = useMemo<MultiSelectOption[]>(
    () => journeyNameOptions.map((title) => ({ label: title, value: title })),
    [journeyNameOptions]
  );

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button iconOnly variant="ghost" size="sm" color="muted" hoverLabel={t("Filter journeys")}>
          <ListFilter />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-96 p-2" align="end">
        <FilterBlockEditor
          block={filterBlock}
          fieldOptions={fieldOptions}
          onChange={onFilterChange}
          onRemove={() => onFilterChange({ ...filterBlock, filters: [] })}
          renderValueInput={({ filter, onChange }) =>
            filter.field === "journey" ? (
              <MultiSelect
                className="w-full bg-white text-xs font-light"
                minPopoverWidth={240}
                options={journeySelectOptions}
                value={Array.isArray(filter.value) ? filter.value : []}
                onValueChange={(value) => onChange({ ...filter, value })}
                placeholder={t("Select journeys")}
                creator={{
                  render: (input) => t('Add "{{title}}"', { title: input }),
                  transform: (input) => input,
                  onCreate: () => {},
                }}
              />
            ) : undefined
          }
        />
      </PopoverContent>
    </Popover>
  );
};
